/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const SegmentTableContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),

  '.MuiTableCell-root .MuiTypography-root': {
    fontWeight: 400,
    fontSize: '14px !important',
    lineHeight: '16px !important',
  },
}));

export const SegmentHeader = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  fontSize: '24px',
  lineHeight: '28px',
  padding: theme.spacing(0, 6),
}));
